import { CollectionList, Form } from '@mairistem/composants';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import { validateMail, validatePhone } from '@/utils';
import PayeurContactListItem from './PayeurContactListItem';
import PayeurContactListItemForm from './PayeurContactListItemForm';

interface PayeurContactListProps {
  telephone: string;
  portable: string;
  mail: string;
  disabled: boolean;
  onChange: (e: any) => void;
  control?: React.ReactNode;
  form?: React.ReactNode;
}

const PayeurContactList = (props: PayeurContactListProps) => {
  const {
    telephone,
    portable,
    mail,
    disabled,
    onChange,
    control = PayeurContactListItem,
    form = PayeurContactListItemForm,
  } = props;

  const items = React.useMemo(() => {
    if (telephone || portable || mail) {
      return [
        {
          key: '1',
          telephone,
          portable,
          mail,
        },
      ];
    }

    return disabled ? [{}] : [];
  }, [telephone, portable, mail, disabled]);

  const handleChange = React.useCallback(
    (e, item) => {
      const errors: Record<string, string> = {};

      // Validate le numéro de téléphone fixe
      const telErrors = validatePhone(item.telephone);

      if (!_.isEmpty(item.telephone) && !_.isEmpty(telErrors)) {
        errors.telephone = _.head(telErrors)?.message;
      }

      // Validate le numéro de téléphone portable
      const telPortableErrors = validatePhone(item.portable);

      if (!_.isEmpty(item.portable) && !_.isEmpty(telPortableErrors)) {
        errors.portable = _.head(telPortableErrors)?.message;
      }

      const mailErrors = validateMail(item.mail);

      if (!_.isEmpty(item.mail) && !_.isEmpty(mailErrors)) {
        errors.mail = _.head(mailErrors)?.message;
      }

      if (_.isEmpty(errors)) {
        onChange({
          ..._.omit(item, 'key'),
        });

        return null;
      }

      return errors;
    },
    [onChange],
  );

  return (
    <Form.Group width={16}>
      <Form.Field width={16} required disabled={disabled}>
        <label>Informations de contact</label>
        <CollectionList
          id="contact"
          limit={1}
          formTitle="Contact"
          // @ts-expect-error
          items={items}
          {...(!disabled && {
            onItemCreate: handleChange,
            onItemUpdate: handleChange,
          })}
          itemControl={control as ReactNode}
          itemForm={form as ReactNode}
          modal={{ size: 'mini' }}
          style={{ margin: 0 }}
        />
      </Form.Field>
    </Form.Group>
  );
};

export default PayeurContactList;
